import { Component, OnDestroy, OnInit } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { Subscription } from 'rxjs';
import { DynamicFormService } from '../../dynamic-form/dynamic-form.service';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-formly-radio-input-with-side-description',
    templateUrl: './formly-radio-input-with-side-description.component.html',
    standalone: true,
    imports: [CommonModule, TranslateModule, ReactiveFormsModule, FormlyModule]
})

export class FormlyRadioWithSideDescriptionComponent extends FieldType implements OnInit, OnDestroy {

  param: any;
  isFormSubmitted: boolean = false;
  formSubmissionSubscription: Subscription;
  fieldKey: string;

  constructor(
    private dynamicFormService: DynamicFormService
  ) {
    super();
  }

  ngOnInit() {
    if (this.field.key) {
      this.fieldKey =this.field.id??this.field.key.toString();
    }
    this.formSubmissionSubscription = this.dynamicFormService.getFormSubmittedEvent().subscribe(data => {
      this.isFormSubmitted = data;
    });
  }

  ngOnDestroy() {
    if (this.formSubmissionSubscription) {
      this.formSubmissionSubscription.unsubscribe();
    }
  }

  onValueChange() {
    if (this.to.change) {
      this.to.change(this.field, this.formControl.value);
    }
  }
}


